import { NgModule } from '@angular/core';
import { NgNiceSelectDirective } from './ng-nice-select.directive';

@NgModule({
  declarations: [NgNiceSelectDirective],
  imports: [],
  exports: [NgNiceSelectDirective]
})
export class NiceSelectModule { }
